import { StyledLinearProgress } from "./styled";
import { ILinearProgressProps } from "./types";

const LinearProgress = ({color = "primary",...props}: ILinearProgressProps)=>{
    return (
        <StyledLinearProgress {...props} customColor={color} />
    )
}

export { LinearProgress };